import updateUserName from 'utils/api/updateUserName';
import React, { useState } from 'react';
import { useMutation } from 'react-query';
import './UsersRequireName.less';
import { getQueryParamByName } from 'utils/urlDecoder';
var getHumanReadableErrorMessage = function (error) {
    if (error.status >= 500) {
        return 'Serveren feilet. Vennligst prøv igjen senere.';
    }
    if (error.status >= 400 && (error === null || error === void 0 ? void 0 : error.detail)) {
        return error.detail;
    }
    if (error.status >= 400) {
        return 'Du sendte ugyldig tegn. Vennligst prøv noe annet.';
    }
    console.error('Unknown error condition. Could not create custom error message', error);
    // General message if we don't catch the relevant message.
    return 'Noe gikk galt. Vennligst prøv igjen senere eller ta kontakt med oss på brukerstøtte.';
};
function isIllegalCharacters(name) {
    var illegalCharacters = '!"#¤%&/()=?`}][{$£€@|^*<>';
    var nameChars = name.split('');
    return nameChars.some(function (char) { return illegalCharacters.indexOf(char.toLowerCase()) !== -1; });
}
var validateName = function (name) {
    var trimmedName = name.trim();
    var validationText = null;
    if (trimmedName.length < 2 || trimmedName.length > 100) {
        validationText = 'Navnet må være mellom 2 og 100 tegn.';
    }
    if (isIllegalCharacters(trimmedName)) {
        validationText = 'Vennligst benytt gyldige tegn.';
    }
    return validationText;
};
var getSafeRedirect = function () {
    var redirect = getQueryParamByName('redirect');
    if (!redirect || !redirect.startsWith('/') || redirect.startsWith('//') || redirect.startsWith('/registrer_navn')) {
        return '/chat';
    }
    return redirect;
};
var UsersRequireName = function () {
    var _a;
    var _b = useState(''), name = _b[0], setName = _b[1];
    var _c = useState(''), helperText = _c[0], setHelperText = _c[1];
    var mutation = useMutation(function (username) { return updateUserName(username); }, {
        onSuccess: function () {
            // Name has successfully been updated, redirect to the correct page
            window.location.href = getSafeRedirect();
        },
    });
    var handleSubmit = function (event) {
        event.preventDefault();
        var validationText = validateName(name);
        if (validationText) {
            setHelperText(validationText);
            return;
        }
        setHelperText('');
        mutation.mutate(name);
    };
    // Give user feedback after submiting name
    var error = (_a = mutation.error) === null || _a === void 0 ? void 0 : _a.data;
    var errorMessage;
    var successMessage;
    if (error) {
        errorMessage = getHumanReadableErrorMessage(error);
    }
    else if (mutation.isSuccess) {
        successMessage = 'Vellykket oppdatering av navn.';
    }
    var handleCancel = function () {
        window.location.replace('/');
    };
    return (React.createElement("div", { className: "usersrequirename" },
        React.createElement("div", { className: "registerName" },
            React.createElement("h1", null, "Registrer navn"),
            React.createElement("p", { className: "registerName__about" }, "Du m\u00E5 registrere et navn for \u00E5 benytte deg av v\u00E5re chat-tjenester slik at navnet ditt blir synlig for mottaker."),
            React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("label", { className: "field-label", htmlFor: "nameInput" }, "Skriv inn navn"),
                React.createElement("input", { style: (helperText || errorMessage) ? { border: '1px solid red' } : {}, name: "nameInput", className: "nameInput", placeholder: "Navn Navnesen", onChange: function (event) { return setName(event.target.value); }, value: name, type: "text" }),
                React.createElement("p", null, successMessage || helperText || errorMessage),
                React.createElement("div", { className: "btnContainer" },
                    React.createElement("button", { className: "cancelBtn", onClick: handleCancel, type: "reset" }, "Avbryt"),
                    React.createElement("button", { className: "registerBtn", type: "submit" }, "Registrer navn"))))));
};
export default UsersRequireName;
